"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let PaymentBatchRenewModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.auto_renew = false;
    this.show_auto_renew = true;
    this.goods_spec = [];
  }
};
PaymentBatchRenewModel.model = "payment.virtualdesktop.options.renew";
PaymentBatchRenewModel = __decorateClass([
  Annotation.ModelMeta
], PaymentBatchRenewModel);
